module.exports = __webpack_public_path__ + "8163899ced9cdfb38349f90ced8e1ec5.pdf";